import { render } from "./Info.vue?vue&type=template&id=0661a770&scoped=true&ts=true"
import script from "./Info.vue?vue&type=script&lang=ts"
export * from "./Info.vue?vue&type=script&lang=ts"

import "./Info.vue?vue&type=style&index=0&id=0661a770&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\lq\\Desktop\\普康\\activity-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0661a770"]])

export default __exports__